export class DeleteLogSectorById{
    constructor(repository){
        this.repository=repository
    }
    async execute(FK_SECTOR){
        const hasDataRegister= await this.repository.checkIfEmpty(FK_SECTOR)
        if(hasDataRegister){
          return  await this.repository.deleteByFkSector(FK_SECTOR)
        }
        return
    }
}
